import { createSlice } from '@reduxjs/toolkit'

const reducer = createSlice({
  name: 'decisionMakersSet',
  initialState: {
    id: null,
    name: '',
    description: '',
    decisionMakers: [],
    oneOffSetForActionId: null,
    lookupKind: null,
    actionExcludedDecisionMakerIds: [],
  },
  reducers: {
    upsert: (s, a) => ({ ...s, ...a.payload }),
    set: (s, a) => a.payload,
    upsertDecisionMaker: (s, a) => {
      let updated = false
      const uniqueDecisionMakers = s.decisionMakers.map(dm => {
        if (dm.email === a.payload.email) {
          updated = true
          return { ...dm, name: a.payload.name }
        }
        if (dm.email === a.payload?.oldEmail) {
          updated = true
          return { ...dm, email: a.payload.email, name: a.payload?.name ?? dm.name }
        }
        return dm
      })
      if (!updated) uniqueDecisionMakers.push(a.payload)
      
      return { ...s, decisionMakers: uniqueDecisionMakers }
    },
    removeDecisionMaker: (s, a) => {
      const { email } = a.payload
      let remainingDecisionMakers = s.decisionMakers.filter(dm => dm.email !== email)
      return { ...s, decisionMakers: remainingDecisionMakers }
    }
  },
}).reducer

const actions = (dis, store, restClient) => {
  const loadDecisionMakersSet = (decisionMakerSetId, actionId = null) => {
    return restClient.get(`/api/decision_maker_sets/${decisionMakerSetId}`, { params: { actionId: actionId } })
      .then(response => {
        let data = response.data
        dis({ type: 'decisionMakersSet/set', payload: { ...data.decisionMakerSet, actionExcludedDecisionMakerIds: data.actionExcludedDecisionMakerIds } })
      })
  }
  const initialiseNewDecisionMakersSet = (name, actionId) => {
    dis({ type: 'decisionMakersSet/set', payload: { 
      id: uuidv4(), 
      name: name, 
      description: '', 
      decisionMakers: [], 
      oneOffSetForActionId: actionId, 
      lookupKind: 'manual',
      actionExcludedDecisionMakerIds: []
    } })
  }

  const setName = (name) => {
    dis({ type: 'decisionMakersSet/upsert', payload: { name: name } })
  }
  const setDescription = (description) => {
    dis({ type: 'decisionMakersSet/upsert', payload: { description: description } })
  }
  const upsertDecisionMaker = (email, name) => {
    dis({ type: 'decisionMakersSet/upsertDecisionMaker', payload: { email: email, name: name } })
  }
  const setDecisionMakerEmail = (oldEmail, newEmail) => {
    dis({ type: 'decisionMakersSet/upsertDecisionMaker', payload: { email: newEmail, oldEmail: oldEmail } })
  }
  const setDecisionMakerName = (email, newName) => {
    dis({ type: 'decisionMakersSet/upsertDecisionMaker', payload: { name: newName, email: email } })
  }
  const removeDecisionMaker = (email) => {
    dis({ type: 'decisionMakersSet/removeDecisionMaker', payload: { email } })
  }
  const commit = () => {
    restClient.post('/api/decision_maker_sets', {
      decisionMakerSet: { ...store.getState().decisionMakersSet },
    }).then(response => {
      let decisionMakersSet = response.data.decisionMakerSet
      dis({ type: 'decisionMakersSet/set', payload: { ...decisionMakersSet } })
    }).catch(error => {
      dis({ type: 'local/upsert', payload: { errors: error.response.data.errors } })
    })
  }
  const setDecisionMakerExcludedIds = (actionExcludedDecisionMakerIds) => {
    dis({ type: 'decisionMakersSet/upsert', payload: { actionExcludedDecisionMakerIds } })
  }

  return {
    initialiseNewDecisionMakersSet,
    loadDecisionMakersSet,
    setName,
    setDescription,
    upsertDecisionMaker,
    setDecisionMakerEmail,
    setDecisionMakerName,
    removeDecisionMaker,
    commit,
    setDecisionMakerExcludedIds
  }
}

export { reducer, actions }
export default { reducer, actions }
